// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compt .car-inner-wrap .car-inner .car-fields .cb-row {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.compt.not-visible-on-map .car-inner {
  opacity: 0.5;
}
.compt.selected {
  background-color: var(--selected-background-color, #0455BF);
}
.compt.selected .car-inner-wrap {
  border-bottom-color: var(--selected-background-color, #0455BF);
}
.compt.selected .car-inner-wrap .cb-name, .compt.selected .car-inner-wrap .cb-status-lbl, .compt.selected .car-inner-wrap .fz0 {
  color: var(--selected-text-color, white) !important;
}
.compt .car-inner-wrap {
  margin-left: var(--margin-page, 20px);
  border-bottom: 1px solid var(--border-divider-color, #d3cdcd);
  padding-right: var(--padding-right, 15px);
  display: flex;
}
.compt .car-inner-wrap.noLines {
  border-bottom: none;
}
.compt .car-inner-wrap .car-inner {
  flex: 1;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.compt .car-inner-wrap .car-inner .car-avt {
  margin-right: 15px;
  border-radius: 50%;
  padding: 0 6px;
  height: 40px;
  width: 40px;
  background-color: var(--avatar-background-color, #dfe5ea);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}
.compt .car-inner-wrap .car-inner .car-avt.no-rounded {
  border-radius: 4px;
}
.compt .car-inner-wrap .car-inner .car-avt .avt-lbl {
  color: var(--avatar-label-color, #374957);
  font-size: 15px;
  font-weight: 500;
  display: flex;
  justify-content: flex-end;
  overflow-x: hidden;
}
.compt .car-inner-wrap .car-inner .car-avt .avt-pic {
  display: flex;
}
.compt .car-inner-wrap .car-inner .car-avt .avt-pic.big {
  font-size: 23px;
  color: var(--avatar-label-color, #374957);
}
.compt .car-inner-wrap .car-inner .car-avt.avatar-only {
  border: initial;
  background: initial;
}
.compt .car-inner-wrap .car-inner .car-fields {
  flex: 1;
  display: grid;
}
.compt .car-inner-wrap .car-inner .car-fields .cb-row.cb-name {
  color: var(--title-color, #374957);
  font-weight: 500;
}
.compt .car-inner-wrap .car-inner .car-fields .cb-row.cb-name:not(:last-child) {
  margin-bottom: 2px;
}
.compt .car-inner-wrap .car-inner .car-fields .cb-row.cb-status-lbl {
  color: var(--rows-color, #5f7d95);
  font-size: 13px;
}
.compt .car-inner-wrap .car-inner .car-fields .cb-row.cb-status-lbl.fz10 {
  font-size: 10px;
  color: var(--second-row-color, var(--rows-color, #5f7d95));
}
.compt .car-inner-wrap .car-inner .car-fields .cb-row.cb-status-lbl.fz10 .csl-icon {
  margin-right: 1px;
  font-size: 9px;
}
.compt .car-inner-wrap .car-inner .w-status {
  outline: 3px solid var(--avatar-border-color, var(--avatar-background-color, #dfe5ea));
  outline-offset: 1px;
  padding: 0 4px;
}
.compt .car-inner-wrap .pane-action-btns {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.compt .car-inner-wrap .pane-action-btns .pane-action-btn {
  margin: 0;
  --border-radius: 50%;
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
  height: auto;
}
.compt .car-inner-wrap .pane-action-btns .pane-action-btn .icon-star {
  margin: 5px;
  font-size: var(--right-button-size, 15px);
  color: var(--right-button-color, #0455bf);
}
.compt .car-inner-wrap .pane-action-btns .pane-action-btn .icon-star.selected {
  color: white;
}

.car-avt {
  position: relative;
}
.car-avt .state {
  position: absolute;
  top: -4px;
  left: -4px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid white;
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/avatar-item/avatar-item.component.scss","webpack://./src/theme/desktop/partial/_btn.scss"],"names":[],"mappings":"AAiBA;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;AAhBF;;AAsBI;EACE,YAAA;AAnBN;AAuBE;EACE,2DArBsB;AAA1B;AAuBI;EACE,8DAxBoB;AAG1B;AAuBM;EACE,mDAAA;AArBR;AA0BE;EACE,qCA1CS;EA2CT,6DAAA;EACA,yCA3CW;EA4CX,aAAA;AAxBJ;AA0BI;EACE,mBAAA;AAxBN;AA2BI;EACE,OAAA;EAGA,gBADK;EAEL,mBAFK;EAGL,mBAAA;EAEA,eAAA;EAEA,aAAA;EACA,mBAAA;AA7BN;AA+BM;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EAEA,YAAA;EACA,WAAA;EAEA,yDArEgB;EAuEhB,sBAAA;EACA,2BAAA;EACA,4BAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjCR;AAmCQ;EACE,kBAAA;AAjCV;AAoCQ;EACE,yCAnFS;EAqFT,eAAA;EACA,gBAAA;EAEA,aAAA;EACA,yBAAA;EAEA,kBAAA;AArCV;AAuCQ;EACE,aAAA;AArCV;AAsCU;EACE,eAAA;EACA,yCAAA;AApCZ;AAwCQ;EACE,eAAA;EACA,mBAAA;AAtCV;AA0CM;EACE,OAAA;EACA,aAAA;AAxCR;AA8CU;EACE,kCAlHC;EAmHD,gBAAA;AA5CZ;AA8CY;EACE,kBAAA;AA5Cd;AAiDU;EACE,iCA3HA;EA4HA,eAAA;AA/CZ;AAiDY;EACE,eAAA;EACA,0DA/HG;AAgFjB;AAiDc;EACE,iBAAA;EACA,cAAA;AA/ChB;AAwDM;EACE,sFAAA;EACA,mBAAA;EACA,cAAA;AAtDR;AA2DI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAzDN;AA2DM;ECrIL,SAAA;EACA,oBAAA;EAvBC,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EAwBD,YAAA;AD8ED;AAqDQ;EACE,WAAA;EACA,yCA3JQ;EA4JR,yCA3JS;AAwGnB;AAqDU;EACE,YAAA;AAnDZ;;AA+DA;EACE,kBAAA;AA5DF;AA6DE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;AA3DJ","sourcesContent":["@use \"../../../../theme/desktop/partial/btn\";\n\n$marginPage: var(--margin-page, 20px); // margine di pagina (dist avatar da bordo sx)\n$paddingRight: var(--padding-right, 15px); // padding di dx\n$borderDividerColor: var(--border-divider-color, #d3cdcd); // colore del bordo separatore da gli item di lista\n$avatarBackgroundColor: var(--avatar-background-color, #dfe5ea); // colore sfondo avatar\n$avatarLabelColor: var(--avatar-label-color, #374957); // colore testo in avatar\n$avatarBorderColor: var(--avatar-border-color, $avatarBackgroundColor); // colore bordo avatar\n$titleColor: var(--title-color, #374957); // colore titolo\n$rowsColor: var(--rows-color, #5f7d95); // colore righe dopo titolo\n$secondRowColor: var(--second-row-color, $rowsColor); // colore seconda riga\n$selectedBackgroundColor: var(--selected-background-color, #0455BF); // colore sfondo elemento selezionato\n$selectedTextColor: var(--selected-text-color, white); // colore sfondo elemento selezionato\n$rightButtonSize: var(--right-button-size, 15px); // dimensione carattare bottone di dx\n$rightButtonColor: var(--right-button-color, #0455bf); // colore bottone di dx\n\n\n%oneLiner {\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n.compt {\n\n  &.not-visible-on-map {\n    .car-inner {\n      opacity: .5;\n    }\n  }\n\n  &.selected {\n    background-color: $selectedBackgroundColor;\n\n    .car-inner-wrap {\n      border-bottom-color: $selectedBackgroundColor;\n\n      .cb-name, .cb-status-lbl, .fz0{\n        color: $selectedTextColor!important;\n      }\n    }\n  }\n\n  .car-inner-wrap {\n    margin-left: $marginPage;\n    border-bottom: 1px solid $borderDividerColor;\n    padding-right: $paddingRight;\n    display: flex;\n\n    &.noLines{\n      border-bottom: none;\n    }\n\n    .car-inner {\n      flex: 1;\n\n      $py: 8px;\n      padding-top: $py;\n      padding-bottom: $py;\n      padding-right: 10px;\n\n      cursor: pointer;\n\n      display: flex;\n      align-items: center;\n\n      .car-avt {\n        margin-right: 15px;\n        border-radius: 50%;\n        padding: 0 6px;\n\n        height: 40px;\n        width: 40px;\n\n        background-color: $avatarBackgroundColor;\n\n        background-size: cover;\n        background-position: center;\n        background-repeat: no-repeat;\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        &.no-rounded {\n          border-radius: 4px;\n        }\n\n        .avt-lbl {\n          color: $avatarLabelColor;\n\n          font-size: 15px;\n          font-weight: 500;\n\n          display: flex;\n          justify-content: flex-end;\n\n          overflow-x: hidden;\n        }\n        .avt-pic {\n          display: flex;\n          &.big{\n            font-size: 23px;\n            color: var(--avatar-label-color, #374957);\n          }\n        }\n\n        &.avatar-only {\n          border: initial;\n          background: initial;\n        }\n      }\n\n      .car-fields {\n        flex: 1;\n        display: grid;\n\n        .cb-row {\n          @extend %oneLiner;\n\n\n          &.cb-name {\n            color: $titleColor;\n            font-weight: 500;\n\n            &:not(:last-child) {\n              margin-bottom: 2px;\n            }\n          }\n\n\n          &.cb-status-lbl {\n            color: $rowsColor;\n            font-size: 13px;\n\n            &.fz10 {\n              font-size: 10px;\n              color: $secondRowColor;\n\n              .csl-icon {\n                margin-right: 1px;\n                font-size: 9px;\n              }\n            }\n\n          }\n\n        }\n      }\n\n      .w-status {\n        outline: 3px solid $avatarBorderColor;\n        outline-offset: 1px;\n        padding: 0 4px;\n      }\n\n    }\n\n    .pane-action-btns {\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n\n      .pane-action-btn {\n        @include btn.btn-circle;\n\n        .icon-star {\n          margin: 5px;\n          font-size: $rightButtonSize;\n          color: $rightButtonColor;\n\n          &.selected{\n            color: white;\n          }\n        }\n      }\n    }\n\n\n\n  }\n\n}\n\n.car-avt{\n  position: relative;\n  .state{\n    position: absolute;\n    top: -4px;\n    left: -4px;\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    border: 1px solid white;\n    background-color: white;\n  }\n}\n\n","// @each $size in $sizes {\n//   &.fz-#{$size} {\n//     font-size: $size + px;\n//   }\n// }\n\n\n@mixin p($p: 0) {\n  --padding-top: #{$p};\n  --padding-bottom: #{$p};\n  --padding-start: #{$p};\n  --padding-end: #{$p};\n}\n\n\n\n// * works!\n// %btn-circle {\n// \tmargin: 0;\n// \t--border-radius: 50%;\n\t\n// \t@include p;\n\t\n// \theight: auto;\n// }\n\n@mixin btn-circle {\n\t// * works!\n\t// @extend %btn-circle;\n\t\n\tmargin: 0;\n\t--border-radius: 50%;\n\t\n\t@include p;\n\t\n\theight: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
